import uploadWhyHostData from '../../../actions/siteadmin/uploadWhyHostData';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {
	const isRestrict = await dispatch(demoRestriction({}));
	if (isRestrict) return;

	const dataList = values.dataList?.length > 0
		? values.dataList.map(item => ({
			id: item.id || null,
			imageName: item.imageName || null,
			title: item.dynamicWhyHost?.[0]?.title || item.title || null,
			buttonLabel: item.dynamicWhyHost?.[0]?.buttonLabel || item.buttonLabel || null,
			dynamicWhyHost: item.dynamicWhyHost?.filter(d => d?.language) || []
		}))
		: [];

	await dispatch(uploadWhyHostData(JSON.stringify(dataList)));
}

export default submit;